export enum ReportStatus {
  None = 'None',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Failed = 'Failed',
}
